<template>
  <div class="bg_m">
    <div class="bg"><img :src="imgsrc" width="100%" height="100%" alt=""/></div>  
    <div class="pc_Popup">
      <div class="personal">PC端登录个人账户密码</div>
      <div class="account" style="margin-bottom: 0.35rem;">
        <div class="accont_title">账户:</div>
        <div class="accont_text">{{userInfo.account}}</div>
      </div>
      <div class="account">
        <div class="accont_title">密码:</div>
        <div class="accont_text">{{userInfo.password}}</div>
      </div>
      <div class="jietu">--请截图保存以便下次在PC端登录使用--</div>
    </div>
  </div>    
</template>

<script>
export default {
  name: '',
  data () {
    return {
      // imgsrc: 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211109d5e1bb476b01d51c732870.jpg',
      imgsrc: 'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211213a2c3a7a3b4ed0426195735.jpeg',
      userInfo: {}
    }
  },
  created() {
    // window.localStorage.setItem("token", 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NDA4ODAwMDAsInVzZXJJZCI6MjUsInByb2plY3QiOiJIdWFGYSJ9.0nI4WD2neUJeNUqmm4LNfeezXXSp6oJ7z3BQdrASir4');
    let token = window.localStorage.getItem('token')
    console.log(token)
    if (token) {
      this.getInfo()
    } else {
      if (this.getQueryVariable('token')) {
        console.log('获取url')
        window.localStorage.setItem('token', this.getQueryVariable('token'))
        this.getInfo()
      } else {
        console.log('跳转')
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx181996f6b106fd40&redirect_uri=https://h5api.xiaoxxx.cn/h5/huaFaH5/callback?returnUrl=https://h5case4.xiaoxxx.cn/202110/HUAFA_PC/dist/index.html&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx181996f6b106fd40&redirect_uri=https://h5api.xiaoxxx.cn/h5/huaFaH5/callback?returnUrl=https://huafavideo.xiaoxxx.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      }
    }
  },
  mounted() {
    
  },
  methods: {
    getInfo() {
      console.log('getInfo')
      window.fetch('https://h5api.xiaoxxx.cn/h5/huaFaH5/getUserInfo', {
        method: 'POST',
        headers: {
          'Authorization': window.localStorage.getItem('token')
        }
      }).then(res => {
        console.log(res)
        return res.json();
      }).then(res => {
        if (res.code == 0) {
          this.userInfo = res.data.userInfo
        } else {
          alert(res.message)
          window.localStorage.removeItem('token')
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx181996f6b106fd40&redirect_uri=https://h5api.xiaoxxx.cn/h5/huaFaH5/callback?returnUrl=https://h5case4.xiaoxxx.cn/202110/HUAFA_PC/dist/index.html&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
.bg{
  width:100%;  
  height:100%;  /**宽高100%是为了图片铺满屏幕 */
  z-index:-1;
  overflow: hidden;
  position: absolute;
  
}
.pc_Popup{
    display: flex;
    justify-content: center;
    flex-direction:column;
    margin-top: 50%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50%;
    width: 87%;
    border: 1px solid rgb(190, 190, 190);
    background: rgb(255, 255, 255);
    border-radius:5%;
    position:absolute;
    left: 50%;
    transform: translateY(-50%);
    transform: translatex(-50%);
  }
  .personal{
    font-size: 0.34rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    margin-bottom: 0.8rem;
    font-weight: bolder;
  }
  .account{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .accont_title{
    font-size:0.31rem;
    margin-right: 0.44rem;
    font-weight: bolder;
  }
  .accont_text{
    font-size:0.31rem;
  }
  .jietu{
    color: #898989;
    font-size: 0.25rem;
    margin: 0 auto;
    margin-top: 0.65rem;
    margin-bottom: 2.08rem;
  }
    
</style>



// WEBPACK FOOTER //
// src/components/pc_Popup.vue